import React from "react";
import EcommerceStore from "./components/EcommerceStore";

function App() {
  return (
    <div className="App">
      <EcommerceStore />
    </div>
  );
}

export default App;
